import { render, staticRenderFns } from "./LahanVerificationUm.vue?vue&type=template&id=c1bd0fda"
import script from "./LahanVerificationUm.vue?vue&type=script&lang=js"
export * from "./LahanVerificationUm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports